module.exports = __webpack_public_path__ + "img/iphone.412c7c2b.png";